/**
 * Controla la tabla de inspecciones.
 */
CamposExtraDetallesCtrl.$inject = ['$q', '$scope', 'CampoExtra', '$timeout'];
export default function CamposExtraDetallesCtrl($q, $scope, CampoExtra, $timeout) {

    const campExtDet = this;
    const soloObligatorios = issetAndNotEmpty(campExtDet.onlyRequired) ? campExtDet.onlyRequired : false;

    campExtDet.cargando = true;
    campExtDet.actualizado = false;
    campExtDet.camposExtra = [];

    campExtDet.updateActive = false;

    campExtDet.puedeEditarCamposExtra = Sigo.user.puedeEditarCamposExtra;

    campExtDet.actualizar = actualizar;
    $scope.actualizar = actualizar;

    campExtDet.actualizar();

    function actualizar() {
        campExtDet.cargando = true;

        CampoExtra.get(campExtDet.modelId, soloObligatorios)
            .then(function (data) {
                if (isArray(data.data) && data.data.length > 0) {
                    campExtDet.camposExtra = chunkArray(data.data, 4);
                    $('#' + campExtDet.tagId + '[data-id="' + campExtDet.modelId + '"]').parent().removeClass('ocultar');
                } else {
                    $('#' + campExtDet.tagId + '[data-id="' + campExtDet.modelId + '"]').parent().addClass('ocultar');
                }
                campExtDet.cargando = false;
            }, function () {
                campExtDet.cargando = false;
            });
    }

    function actualizaCamposExtra() {
        campExtDet.cargando = true;
        campExtDet.actualizado = false;

        const promesas = [];

        for (let i = 0; i < campExtDet.camposExtra.length; i++) {
            for (let j = 0; j < campExtDet.camposExtra[i].length; j++) {
                const campoExtra = campExtDet.camposExtra[i][j];
                if (issetAndNotEmpty(campoExtra.changed) && campoExtra.changed) {
                    campoExtra.changed = false;
                    promesas.push(
                        campoExtra.valor != null
                            ? CampoExtra.update(campExtDet.modelId,
                                {
                                    campoExtraId: campoExtra.id,
                                    valor: campoExtra.valor,
                                    valor_descripcion: campoExtra.valor_descripcion,
                                    valor_json: campoExtra.valor_json
                                })
                            : CampoExtra.delete(campExtDet.modelId, campoExtra.id)
                    );
                }
            }
        }

        $q.all(promesas).then(
            function () {
                actualizar();
                campExtDet.cargando = false;
                campExtDet.actualizado = true;
                $timeout(() => {
                    campExtDet.actualizado = false;
                }, 2000);
            },
            function () {
                campExtDet.cargando = false;
            });
    }

    $scope.$watch("campExtDet.camposExtra", function (val) {
        let hayAlgunCampoExtraCambiado = false;
        for (let i = 0; i < val.length; i++) {
            for (let j = 0; j < val[i].length; j++) {
                const campoExtra = val[i][j];
                if (issetAndNotEmpty(campoExtra.changed) && campoExtra.changed) {
                    hayAlgunCampoExtraCambiado = true;
                }
            }
        }

        if (hayAlgunCampoExtraCambiado) actualizaCamposExtra();
    }, true);

    campExtDet.obtenerClases = function (campoExtra) {
        if (campoExtra.json != null && campoExtra.json != "") {
            const json = angular.fromJson(campoExtra.json);
            if (typeof json.clases !== "undefined") {
                return json.clases;
            }
        }
        return ["three"];
    };

    campExtDet.actualizaUpdateActive = function () {
        campExtDet.updateActive = !campExtDet.updateActive;
    };
    
    campExtDet.soloTieneIframes = function() {
        // Verificar si todos los campos extra son de tipo iframe
        let soloIframes = true;
        
        if (campExtDet.camposExtra.length === 0) {
            return false;
        }
        
        for (let i = 0; i < campExtDet.camposExtra.length; i++) {
            for (let j = 0; j < campExtDet.camposExtra[i].length; j++) {
                if (campExtDet.camposExtra[i][j].tipo_campo !== 'iframe') {
                    soloIframes = false;
                    break;
                }
            }
            if (!soloIframes) break;
        }
        
        return soloIframes;
    };
}